"use client";

import React, { useState } from "react";

// styled
import * as S from "./styles";

// Icons
import { ChevronLeft, ChevronRight } from "lucide-react";

// Helpers
import { format, isToday, subDays, addDays, parseISO, isEqual } from "date-fns";

// Types
import { SelectDateGroupProps } from "@/types";

const SelectDateGroup: React.FC<SelectDateGroupProps> = ({
  className,
  options,
  selectedDate,
  onDateChange,
}) => {
  const today = new Date();

  // Cria uma lista de strings de datas válidas (ex: ['2025-06-07', ...])
  const validDates = options.map((option) => option.value.toString());

  const formattedDate = format(selectedDate, "yyyy-MM-dd");

  const handlePrevDate = () => {
    const prev = subDays(selectedDate, 1);
    const prevFormatted = format(prev, "yyyy-MM-dd");

    if (validDates.includes(prevFormatted)) {
      onDateChange(prev);
    }
  };

  const handleNextDate = () => {
    const next = addDays(selectedDate, 1);
    const nextFormatted = format(next, "yyyy-MM-dd");

    if (validDates.includes(nextFormatted)) {
      onDateChange(next);
    }
  };

  const handleDateChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { target: { name: string; value: any } },
  ) => {
    const newDateStr =
      "target" in e && typeof e.target.value === "string" ? e.target.value : "";
    if (validDates.includes(newDateStr)) {
      onDateChange(parseISO(newDateStr));
    }
  };

  const minDate = validDates[validDates.length - 1];
  const maxDate = validDates[0];

  const isValidSelectedDate = validDates.includes(formattedDate);

  const currentIndex = validDates.indexOf(formattedDate);

  const isPrevDisabled =
    currentIndex === validDates.length - 1 || currentIndex === -1;
  const isNextDisabled = currentIndex === 0 || currentIndex === -1;

  return (
    <S.BoxSelectGroup
      className={`${className ?? ""} ${!isValidSelectedDate ? "disabled-date" : ""}`}
      style={{ opacity: !isValidSelectedDate ? 0.5 : 1 }}
    >
      <S.ButtonsPagination
        icon={<ChevronLeft />}
        variant="success"
        onClick={handlePrevDate}
        disabled={isPrevDisabled}
      />

      <S.SelectDate
        name="select-date"
        type="date"
        value={formattedDate}
        min={minDate}
        max={maxDate}
        onChange={handleDateChange}
        disabled={!isValidSelectedDate}
      />

      <S.ButtonsPagination
        icon={<ChevronRight />}
        variant="success"
        onClick={handleNextDate}
        disabled={isNextDisabled}
      />
    </S.BoxSelectGroup>
  );
};

export default SelectDateGroup;
